import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);

        // DOM
        this.$trigger = this.$('trigger')[0]
        this.$element = this.$('element')[0]
        this.elementStyle = this.$element.style

        // Mouse
        this.mouse = {
            x: 0,
            y: 0,
            smoothX: 0,
            smoothY: 0,
            lerp: 0.1,
        }

        // Vars
        this.isHovering = false
        this.isRunning = false

        // Events
        this.events = {
            mouseenter: {
                'trigger': 'enter'
            },
            mousemove: {
                'trigger': 'move'
            },
            mouseleave: {
                'trigger': 'leave'
            }
        }
    }

    init() {
    }

    enter() {
        this.isHovering = true
        this.isRunning = true
        this.loop()
    }

    leave() {
        this.isHovering = false
        setTimeout(() => {
            this.isRunning = this.isHovering
        }, 500);
    }

    move(e) {
        const rect = e.curTarget.getBoundingClientRect()
        this.mouse.x = e.clientX - rect.left
        this.mouse.y = e.clientY - rect.top
    }

    loop() {

        if(!this.isRunning) {
            return
        }

        let x = this.mouse.smoothX
        x += (this.mouse.x - x) * this.mouse.lerp
        x = ((100 * (x + 0.01)) | 0) / 100

        let y = this.mouse.smoothY
        y += (this.mouse.y - y) * this.mouse.lerp
        y = ((100 * (y + 0.01)) | 0) / 100

        this.mouse.smoothX = x
        this.mouse.smoothY = y

        this.elementStyle.setProperty('--cursor-track-x', `${x}px`)
        this.elementStyle.setProperty('--cursor-track-y', `${y}px`)

        requestAnimationFrame(this.loop.bind(this));
    }

    destroy() {
        this.isRunning = false
    }
}
